import { defineSlotRecipe } from '@chakra-ui/react';
import { selectAnatomy } from '@chakra-ui/react/anatomy';

export const selectSlotRecipe = defineSlotRecipe({
  className: 'aegix-select',
  slots: selectAnatomy.keys(),
  base: {
    trigger: {
      bg: 'surface.secondary',
      color: 'text.primary',
      borderRadius: 'lg',
      height: 'controlHeight',
      px: '3',
      py: '2',
      fontSize: 'md',
      fontWeight: '400',
      width: '100%',
      cursor: 'pointer',
      borderWidth: '1px',
      borderColor: 'border.secondary',
      transitionProperty: 'common',
      transitionDuration: 'normal',
      _hover: {
        borderColor: 'border.tertiary',
      },
      _focusVisible: {
        borderColor: 'border.action',
        boxShadow: '0 0 0 1px var(--chakra-colors-border-action)',
        zIndex: 1,
      },
      _disabled: {
        opacity: 0.6,
        cursor: 'not-allowed',
      },
    },
    content: {
      bg: 'surface.primary',
      borderWidth: '1px',
      borderColor: 'border.secondary',
      borderRadius: 'lg',
      boxShadow: 'lg',
      maxHeight: '300px',
      '--select-z-index': 'zIndex.popover',
      zIndex: 'calc(var(--select-z-index) + var(--layer-index, 0))',
      _focusVisible: {
        outline: '2px solid',
        outlineColor: 'border.action',
        outlineOffset: '-2px',
      },
    },
    item: {
      color: 'text.primary',
      cursor: 'pointer',
      px: '3',
      py: '2',
      transitionProperty: 'common',
      transitionDuration: 'fast',
      _hover: {
        bg: 'surface.secondary',
      },
      _highlighted: {
        bg: 'surface.secondary',
      },
      _checked: {
        bg: 'surface.select',
      },
    },
    indicator: {
      color: 'text.secondary',
    },
    valueText: {
      color: 'text.primary',
      textTransform: 'capitalize',
    },
  },
  variants: {
    visual: {
      outline: {
        trigger: {
          bg: 'surface.primary',
          borderWidth: '1px',
          borderColor: 'border.secondary',
          _hover: {
            borderColor: 'border.tertiary',
          },
          _focusVisible: {
            borderColor: 'border.action',
            boxShadow: '0 0 0 1px var(--chakra-colors-border-action)',
          },
        },
      },
      filled: {
        trigger: {
          bg: 'surface.input',
          borderWidth: '1px',
          borderColor: 'transparent',
          _hover: {
            bg: 'surface.input',
            borderColor: 'border.secondary',
          },
          _focusVisible: {
            bg: 'surface.input',
            borderColor: 'border.action',
            boxShadow: '0 0 0 1px var(--chakra-colors-border-action)',
          },
        },
      },
    },
    size: {
      sm: {
        trigger: {
          height: '32px',
          fontSize: 'sm',
          px: '2',
        },
        item: {
          fontSize: 'sm',
          px: '2',
          py: '1.5',
        },
      },
      md: {
        trigger: {
          height: 'controlHeight',
        },
      },
      lg: {
        trigger: {
          height: 'controlHeightLg',
          fontSize: 'lg',
          px: '4',
        },
        item: {
          fontSize: 'lg',
          px: '4',
          py: '2.5',
        },
      },
    },
  },
  defaultVariants: {
    visual: 'outline',
    size: 'md',
  },
});
